import {SQFTResourceController} from "../SQFTResourceController";
import {
  RESOURCE_TYPE,
  WATERFALL_OVERLAY_TYPE,
  WATERFALL_SHAPES_KEY,
  WORKSPACE_RESOURCES
} from "../../../../../constants";
import store from "../../../../../../../store";
import WaterfallOverlay from "../../../core/shapes/overlays/waterfallOverlay";
import {addResource, changeResource, deleteResource} from "../../../../../../../actions/sqftResourceFunctions";
import workspace from "../../../core/workspace";
import {WaterfallSegmentController} from "./WaterfallSegmentController";

export class WaterfallController extends SQFTResourceController {

  constructor(props) {
    super(props);
    this.resourceName = WORKSPACE_RESOURCES.waterfall;
    this.segmentController = new WaterfallSegmentController(this);
  }

  createWaterfallOverlay = (line, waterfallData = null) => {
    const reduxState = store.getState();
    const waterfallSectionsData = reduxState.sqftResourceState.waterfallSectionsData;
    const waterfallOverlay = new WaterfallOverlay(line, waterfallSectionsData.length + 1, waterfallData);

    this.addResource(waterfallOverlay);
    this.addWaterfallToStore(waterfallOverlay);

    return waterfallOverlay
  }

  createPeninsulaUnderwrapOverlay = (line, waterfallData = null) => {
    const reduxState = store.getState();
    const waterfallSectionsData = reduxState.sqftResourceState.waterfallSectionsData;

    const sectionIndex = waterfallSectionsData.length + 1;
    const waterfallOverlay = new WaterfallOverlay(line, sectionIndex, waterfallData, WATERFALL_OVERLAY_TYPE.peninsulaUnderwrap);

    this.addResource(waterfallOverlay);
    this.addWaterfallToStore(waterfallOverlay);

    return waterfallOverlay
  }

  getResources = () => {
    return workspace[this.resourceName]
  }

  getResourceByLineId = (id) => {
    return workspace[this.resourceName].find(waterFallOverlay => waterFallOverlay.line.id === id);
  }

  getSegmentById = (id) => {
    for (const overlay of this.getResources()) {
      for (const segment of overlay.getSegments()) {
        if (segment.id === id) {
          return segment
        }
      }
    }
  }

  updateWaterfallLength = (line) => {
    if (line.isWithWaterfallToolEdge() || line.isWithPeninsulaUnderwrapEdge()) {
      const waterfallOverlay = this.getResourceByLineId(line.id);
      for (const waterfallOverlaySegment of waterfallOverlay.getSegments()) {
        if (waterfallOverlaySegment.name === WATERFALL_SHAPES_KEY.waterfall) {
          waterfallOverlaySegment.length = line.getLineLength();
        }
        if (waterfallOverlaySegment.name === WATERFALL_SHAPES_KEY.underlayment) {
          const nextLine = line.getParent().getNextLine(line);
          waterfallOverlaySegment.length = nextLine.getLineLength();
        }
      }
      this.changeWaterfallSectionInStore(waterfallOverlay.exportData());
      this.segmentController.scheduleAdditionalShapesRefresh(line);
    }
  }

  changeWaterfallSectionInStore = (waterfallSectionData) => {
    store.dispatch(changeResource(RESOURCE_TYPE.waterfallSectionsData, waterfallSectionData));
  }

  addWaterfallToStore = (waterfallOverlay) => {
    store.dispatch(addResource(RESOURCE_TYPE.waterfallSectionsData, waterfallOverlay.exportData()));
  }

  destroy = (waterfallOverlay) => {
    store.dispatch(deleteResource(RESOURCE_TYPE.waterfallSectionsData, waterfallOverlay.id));
    this.destroyResource(waterfallOverlay);
  }
}
